import { render, staticRenderFns } from "./TqInfo.vue?vue&type=template&id=9384db1a&scoped=true&"
import script from "./TqInfo.vue?vue&type=script&lang=js&"
export * from "./TqInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9384db1a",
  null
  
)

export default component.exports